import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/cms/brands/bg-106.jpg")